export default __webpack_public_path__ + "static/inter-ui-bold-1b33ffda39918d072e27cf47c79372c3.woff2";